module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 002-deeb49c6e72aa3587ee2522117d676fb.png";